import styled from 'styled-components';

// Styled components do AuthField. Match exato com o design Login.html
// (replicado de styled-login.js, agora aqui pra ser reusavel entre
// /login, /signup, /forgot-password, /reset-password).

export const Field = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 0;

  ${(props) =>
    props.$error &&
    `
    > .ctrl {
      border-color: #f4445c;
      background: rgba(244, 68, 92, 0.04);
      box-shadow: 0 0 0 4px rgba(244, 68, 92, 0.08);
    }
    > .ctrl svg.lead { color: #f4445c; }
  `}
`;

export const FieldLabel = styled.label`
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 11.5px;
  font-weight: 700;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: #71767b;

  > a {
    color: #1cb0d8;
    font-weight: 700;
    letter-spacing: 0.08em;
    text-transform: none;
    text-decoration: none;
  }
  > a:hover {
    text-decoration: underline;
  }
  > .hint {
    color: #4a4e54;
    font-weight: 500;
    letter-spacing: 0.04em;
    text-transform: none;
  }
`;

export const Ctrl = styled.div.attrs({ className: 'ctrl' })`
  position: relative;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 0 16px;
  height: 52px;
  background: rgba(255, 255, 255, 0.025);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 14px;
  transition: border-color 0.15s, background 0.15s, box-shadow 0.15s;

  &:hover {
    background: rgba(255, 255, 255, 0.04);
  }
  &:focus-within {
    border-color: #1cb0d8;
    background: rgba(28, 176, 216, 0.04);
    box-shadow: 0 0 0 4px rgba(28, 176, 216, 0.1);
  }
  &:focus-within svg.lead {
    color: #1cb0d8;
  }

  > svg.lead {
    width: 16px;
    height: 16px;
    color: #71767b;
    flex: none;
  }

  > input {
    flex: 1;
    background: transparent;
    border: 0;
    outline: 0;
    color: #e7e9ea;
    font-size: 15px;
    font-weight: 500;
    padding: 0;
    min-width: 0;
    font-family: inherit;

    &::placeholder {
      color: #4a4e54;
    }
  }

  @media (max-width: 480px) {
    height: 48px;
    padding: 0 14px;
  }
`;
